import { Component } from '@angular/core';

@Component({
    selector: 'finder-mobile-tooltip',
    templateUrl: './mobile-tooltip.component.html',
    styleUrls: ['./mobile-tooltip.component.scss']
})
export class MobileTooltipComponent {
    data: any;

    constructor() { }
}
